
export const GET_ALL_SUBSCRIBERS = "GET_ALL_SUBSCRIBERS";
export const GET_ALL_SUBSCRIBERS_SUCCESS = "GET_ALL_SUBSCRIBERS_SUCCESS";
export const GET_ALL_SUBSCRIBERS_FAILURE = "GET_ALL_SUBSCRIBERS_FAILURE";

export const DELETE_SUBSCRIBER = "DELETE_SUBSCRIBER";
export const DELETE_SUBSCRIBER_SUCCESS = "DELETE_SUBSCRIBER_SUCCESS";
export const DELETE_SUBSCRIBER_FAILURE = "DELETE_SUBSCRIBER_FAILURE";